import axios from "axios"
import { API_BASE_URL } from "../config"

export type EffectiveSettingSource = "medical_record" | "catv" | "system" | null
export type PeriodValue = string[] | null

export type MedicalRecordResponse = {
  success: number
  message?: string
  session_code?: string
  medical_record_id?: string
  room_no?: string
  name?: string
  initial?: string
  age?: number
  birthday?: number
  phone?: string
  device_places?: string[]
  setting_device_places?: string[]
  devices?: any[]
  devices_now?: any[]
  service_id?: string
  device_state?: number
  is_poc?: number
  poc_start_date?: number
  last_detect?: string
  last_detect_date?: number
  detection?: number
  alert?: number
  memo?: string
  stop_mail?: number

  sensitivity_enabled?: number | null
  sensitivity?: number | null
  detection_enabled?: number | null
  detection_period?: PeriodValue
  option_enabled?: number | null
  option_period?: PeriodValue

  effective_sensitivity_enabled?: number | null
  effective_sensitivity?: number | null
  effective_sensitivity_source?: EffectiveSettingSource
  effective_detection_enabled?: number | null
  effective_detection_period?: PeriodValue
  effective_detection_period_source?: EffectiveSettingSource
  effective_option_enabled?: number | null
  effective_option_period?: PeriodValue
  effective_option_period_source?: EffectiveSettingSource
}

export const getMedicalRecord = async (id: string): Promise<MedicalRecordResponse | undefined> => {
  for (let i = 0; i < 3; i++) {
    try {
      const response = await axios.post(`${API_BASE_URL}/medical_record`, {
        session_code: localStorage.getItem("session_code"),
        id: id
      })

      if (response.data.session_code) {
        localStorage.setItem("session_code", response.data.session_code)
      }

      return response.data
    } catch (error: any) {
      if (error.code && error.code == "ERR_NETWORK" && i != 2) {
        continue
      }
      throw error
    }
  }
}
